import { Grid } from "@mui/material";
import Typography from "components/common/Typography";

function TableHeader() {
  return (
    <>
      <Grid
        container
        sx={{
          margin: "5px 0",
          padding: "0 30px",
          justifyContent: "space-between"
        }}
      >
        <Grid item md={4}>
          <Typography variant="label">Plan name</Typography>
        </Grid>
        <Grid>
          <Typography variant="label">Functional Area</Typography>
        </Grid>
        <Grid container item md={6}>
          <Grid item md={2}>
            <Typography variant="label">Priority</Typography>
          </Grid>
          <Grid item md={3} paddingLeft="10px">
            <Typography variant="label">Due date</Typography>
          </Grid>
          <Grid item md={4} paddingLeft="10px">
            <Typography variant="label">Status</Typography>
          </Grid>
          <Grid item md={3}>
            <Typography variant="label">Actions</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default TableHeader;
